import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

/**
 * `navigator.onLine` miente hacia el lado optimista: dice que hay red cuando hay wifi de hotel
 * sin salida. Alcanza igual para lo que decide la interfaz, porque el otro lado ya está cubierto:
 * si el envío falla con `NetworkError`, la comida se encola de todos modos.
 */
export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}
